import { mdiCart } from "@mdi/js";
import Icon from "@mdi/react";
import { FormattedMessage } from "react-intl";
import { getSampleOrderLink, SampleSource } from "../../interfaces/Sample";
import { Button } from "./Button";

export function OrderSamplesLink({
	source,
	farmId,
	flockId,
	className,
}: {
	source: SampleSource;
	farmId?: string;
	flockId?: string;
	className?: string;
}) {
	const link = getSampleOrderLink(source, farmId, flockId);

	return (
		<Button href={link} className={className}>
			<span className="icon">
				<Icon path={mdiCart} />
			</span>
			<span>
				<FormattedMessage id="SampleReport_OrderSamples" />
			</span>
		</Button>
	);
}
